import { Box } from "@mui/material";
import React from "react";

import { Icon } from "../Icon";

export const NewMessageIcon = () => (
  <Box sx={{ position: "absolute" }}>
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: 10,
        backgroundColor: "red",
        position: "relative",
        top: 7,
        left: 20,
      }}
    />
    <Icon name="mail" aria-hidden="true" />
  </Box>
);
